// 快訊日曆元件
import dayjs from 'dayjs';
import Image from 'next/image';
const FlashCalendarComponent = ({ v, date, selectedDate }) => {
    // 篩掉同樣標題的事件
    const filterCalendar = v?.calendar
        ?.filter((value, index, self) => index === self.findIndex((t) => t.title === value.title))
        ?.slice(0, 3);

    return (
        <div
            className={`cp relative trans rounded-[4px] overflow-hidden border-1 hover:border-[#00445D]
        ${
            selectedDate === date
                ? 'border-[#00445D] dark:border-[#91FFFF] dark:border-opacity-[.3]'
                : 'border-white1 dark:border-[#393939]'
        }`}
        >
            <span
                className={`absolute top-[5px] right-[5px] rounded-[50%] w-[6px] h-[6px] bg-pale ${
                    selectedDate === date ? '' : 'opacity-[0]'
                }`}
            />
            <p className="text-bd3n py-[6px] text-black text-center">
                {dayjs(date).format('MM/DD')}
            </p>

            {v?.news ? (
                // 新聞
                <div className="img-box w-full aspect-[106/97] after:content-none">
                    <Image width={106} height={97} src={v?.news?.image} alt={v?.news?.title} />
                </div>
            ) : (
                // 日曆
                <div
                    className={`!h-[97px] border-t-1 border-[#efefef] dark:border-[#2d2d2d] flex-col center-center gap-y-[4px] text-pale9 text-bd3b
                ${filterCalendar?.length ? 'px-[10px]' : ''}`}
                >
                    {filterCalendar?.length ? (
                        filterCalendar?.map((c) => (
                            <span
                                className="line-clamp-1 underline decoration-pale9"
                                key={c?.id + c?.title}
                            >
                                {c?.shortTitle || c?.title}
                            </span>
                        ))
                    ) : (
                        // 預設圖片
                        <div className="img-box w-full aspect-[106/97] after:content-none center-center">
                            <Image
                                width={100}
                                height={100}
                                className="!relative !w-[55%] !h-[55%] !aspect-[1/1] !object-contain object-center filter-black8"
                                src="/images/flash/default_flash.svg"
                                alt="default"
                            />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default FlashCalendarComponent;
